import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _get from "lodash/get";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    html {\n        font-size: min(max(", ", ", "vw), ", ");\n    }\n    h1, h2, h3, h4, h5, h6 {\n        ", "\n    }\n    h1 {\n        ", "\n    }\n    h2 {\n       ", "\n    }\n    h3 {\n        ", "\n    }\n    h4 {\n       ", "\n    }\n    h5 {\n        ", "\n    }\n    h6 {\n       ", "\n    }\n    p {\n        ", "\n        &.lead {\n            ", "\n        }\n    }\n    small {\n        ", "\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { createGlobalStyle } from 'styled-components';
import { rem } from 'polished';
import headingStyles from '../styles/headingStyles';
import h1Styles from '../styles/h1Styles';
import h2Styles from '../styles/h2Styles';
import h3Styles from '../styles/h3Styles';
import h4Styles from '../styles/h4Styles';
import h5Styles from '../styles/h5Styles';
import h6Styles from '../styles/h6Styles';
import paragraphStyles from '../styles/paragraphStyles';
import paragraphLeadStyles from '../styles/paragraphLeadStyles';
import smallStyles from '../styles/smallStyles';
import typographyTheme from '../styles/typographyTheme';
var TypographyGlobalStyles = createGlobalStyle(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, 'typography.base.fontSizeMin', typographyTheme.typography.base.fontSizeMin));
}, function (_ref2) {
  var theme = _ref2.theme;
  return _get(theme, 'typography.base.fontSizeViewport', typographyTheme.typography.base.fontSizeViewport);
}, function (_ref3) {
  var theme = _ref3.theme;
  return rem(_get(theme, 'typography.base.fontSizeMax', typographyTheme.typography.base.fontSizeMax));
}, headingStyles, h1Styles, h2Styles, h3Styles, h4Styles, h5Styles, h6Styles, paragraphStyles, paragraphLeadStyles, smallStyles);
export default TypographyGlobalStyles;